var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 12.8206L50 87.1795",
    stroke: "#171A1F",
    strokeWidth: 3.07692
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8203 50L87.1793 50",
    stroke: "#171A1F",
    strokeWidth: 3.07692
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4316 32.0513L82.5675 32.0513",
    stroke: "#171A1F",
    strokeWidth: 3.07692
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4316 67.9487L82.5675 67.9487",
    stroke: "#171A1F",
    strokeWidth: 3.07692
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9996 87.1795C61.6351 87.1795 71.0675 70.5337 71.0675 50C71.0675 29.4664 61.6351 12.8206 49.9996 12.8206C38.3641 12.8206 28.9316 29.4664 28.9316 50C28.9316 70.5337 38.3641 87.1795 49.9996 87.1795Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9998 87.1795C70.5335 87.1795 87.1793 70.5337 87.1793 50C87.1793 29.4664 70.5335 12.8206 49.9998 12.8206C29.4661 12.8206 12.8203 29.4664 12.8203 50C12.8203 70.5337 29.4661 87.1795 49.9998 87.1795Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe8);
export default __webpack_public_path__ + "static/media/Globe 8.0ba637993e44433d80d5a577d1454a44.svg";
export { ForwardRef as ReactComponent };